export default {
    shopCart: {
        Message: {
            stoke: 'Insufficient product inventory!',
            delete: {
                invalid: 'Clear all invalid items?',
                item: 'Delete this item?',
                check: 'Delete selected items?',
                noData: 'Please select at least one item!',
                confirmTitle: 'Confirmation',
                confirmButtonText: 'Confirm',
                cancelButtonText: 'Cancel',
                success: 'Successfully deleted!'
            },
            orderTip: 'Multi-store checkout is not currently supported!'
        },
        Alert: {
            error: {
                title: 'Notice',
                text: 'Data request failed. Please try again.',
                buttonText: 'OK'
            }
        },
        Button: {
            noData: 'Continue Shopping',
            order: 'Checkout'
        },
        Description: {
            msg: 'Note: Due to different payment and shipping methods across stores, multi-store checkout is currently unavailable. We apologize for any inconvenience!',
            noData: 'Your cart is empty~'
        },
        Checkbox: {
            all: 'Select All',
            delete: 'Delete Selected',
            text1: 'Selected ',
            text2: ' items',
            text3: 'Subtotal'
        },
        Table: {
            headerName: ['Product', 'Qty', 'Unit Price', 'Subtotal', 'Action']
        },
        ValidData: {
            item: {
                text: 'Stock:',
                text1:'Negotiable'
            }
        },
        InvalidData: {
            title: 'Unavailable Items',
            delete: 'Clear Unavailable Items',
            item: {
                text1: 'Unavailable',
                text2: 'Product discontinued/out of stock'
            }
        }
    }
}